var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.total)?_c('custom-doughnut-chart',{attrs:{"title":_vm.title,"total":_vm.total,"chartData":_vm.chartData,"width":200,"height":200}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }